"use client";
import { useEffect } from "react";
import { faroManager } from "@/lib/client/faro-manager";
import { useAppStore } from "@/store/appStore";

interface PageTrackerProps {
	pageName: string;
	pageSlug: string;
	additionalAttributes?: Record<
		string,
		string | number | boolean | null | undefined
	>;
}

export default function PageTracker({
	pageName,
	pageSlug,
	additionalAttributes = {},
}: PageTrackerProps) {
	const { data } = useAppStore();
	const user = data?.user;
	const email = user?.employment?.email || data?.email;

	useEffect(() => {
		const trackPageView = async () => {
			await faroManager.waitForInitialization();

			faroManager.pushEvent(`Page Viewed: ${pageName}`, {
				page: pageSlug,
				user_email: email || "anonymous",
				timestamp: new Date().toISOString(),
				...additionalAttributes,
			});
		};

		trackPageView();
	}, [email, pageName, pageSlug, additionalAttributes]);

	return null;
}
